// extracted by mini-css-extract-plugin
export default {"root":"Reasons_root__nKR1k","titleContainer":"Reasons_titleContainer__HtwQJ","container":"Reasons_container__RNGBh","card":"Reasons_card__A0Z-r"};